var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dft-container",style:(_vm.container_Style)},[(_vm.type == '1')?_c('div',{staticClass:"dft-white",style:(_vm.white_Style)}):_vm._e(),(_vm.type == '2')?_c('div',{staticClass:"dft-line",style:(_vm.line_Style)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }